
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'

import { encrypt } from '@/utils/Crypto'

export default {
components: { XInput, XButton, XHeader },
name: "FindPassword",
data() {
return {

resetForm: {
phone: "",
verifyCode: "",
newPassword: "",
confirmPassword: ""
},

passwordType: "password",

inputFocus: [false, false, false, false],
isFormValid: false,

errorTips: {
phone: "",
verifyCode: "",
newPassword: "",
confirmPassword: ""
},

showStrengthBar: false,
strengthLevel: 0, // 1-3级
strengthText: "未设置",

countdown: 0,
countdownInterval: null
};
},
computed: {

isPhoneValid() {
return /^1[3-9]\d{9}$/.test(this.resetForm.phone);
}
},

mounted() {
this.checkCountdownFromStorage();
},

beforeDestroy() {
if (this.countdownInterval) {
clearInterval(this.countdownInterval);
}
},
watch: {

'resetForm.newPassword'(val) {
this.validateForm();
if (val) {
this.showStrengthBar = true;
this.checkPasswordStrength(val);
} else {
this.showStrengthBar = false;
this.strengthLevel = 0;
this.strengthText = "未设置";
}
},

'resetForm.phone'() {
this.validateForm();
},
'resetForm.verifyCode'() {
this.validateForm();
},
'resetForm.confirmPassword'() {
this.validateForm();
}
},
methods: {

togglePasswordVisibility() {
this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
},


onInputFocus(index) {
this.inputFocus = this.inputFocus.map((_, i) => i === index);

const fieldMap = ['phone', 'verifyCode', 'newPassword', 'confirmPassword'];
this.errorTips[fieldMap[index]] = "";
},

onInputBlur(index) {
this.inputFocus[index] = false;

this.validateForm();
},


validateForm() {
const { phone, verifyCode, newPassword, confirmPassword } = this.resetForm;
let isValid = true;
const tips = {
phone: "",
verifyCode: "",
newPassword: "",
confirmPassword: ""
};


if (!phone) {
tips.phone = "请输入手机号";
isValid = false;
} else if (!/^1[3-9]\d{9}$/.test(phone)) {
tips.phone = "请输入正确的手机号码";
isValid = false;
}


if (!verifyCode) {
tips.verifyCode = "请输入验证码";
isValid = false;
} else if (verifyCode.length !== 6) {
tips.verifyCode = "验证码为6位数字";
isValid = false;
}


if (!newPassword) {
tips.newPassword = "请设置新密码";
isValid = false;
} else if (newPassword.length < 8 || newPassword.length > 20) {
tips.newPassword = "新密码长度必须为8-20位";
isValid = false;
}


if (!confirmPassword) {
tips.confirmPassword = "请确认新密码";
isValid = false;
} else if (confirmPassword !== newPassword) {
tips.confirmPassword = "两次输入的密码不一致";
isValid = false;
}


this.errorTips = tips;
this.isFormValid = isValid;
},


checkPasswordStrength(password) {
let level = 0;


if (password.length >= 8) level++;


if (/[A-Z]/.test(password) && /[a-z]/.test(password)) level++; 
if (/[0-9]/.test(password) && /[^A-Za-z0-9]/.test(password)) level++; 

this.strengthLevel = Math.min(level, 3);


switch(this.strengthLevel) {
case 1:
this.strengthText = "弱";
break;
case 2:
this.strengthText = "中";
break;
case 3:
this.strengthText = "强";
break;
default:
this.strengthText = "未设置";
}
},


getLevelColor(level) {
const colors = ['#ff4d4f', '#faad14', '#52c41a']; 
return colors[level - 1] || '#e5e5e5';
},


showToast(message) {
this.$toast({
message,
position: 'top',
duration: 2000
});
},


checkCountdownFromStorage() {
const savedTime = localStorage.getItem('verifyCodeCountdown');
if (savedTime) {
const elapsed = Math.floor((Date.now() - parseInt(savedTime)) / 1000);
const remaining = 60 - elapsed;

if (remaining > 0) {
this.countdown = remaining;


this.countdownInterval = setInterval(() => {
if (this.countdown > 0) {
this.countdown--;
} else {
clearInterval(this.countdownInterval);
localStorage.removeItem('verifyCodeCountdown');
}
}, 1000);
} else {
localStorage.removeItem('verifyCodeCountdown');
}
}
},


sendVerifyCode() {

if (!this.isPhoneValid) {
this.showToast("请输入正确的手机号码");
return;
}



this.$toast.loading({
message: '发送中...',
forbidClick: true,
});

this.$ajax
.post(this.$api.getVerifyCode+"?phone="+this.resetForm.phone, {})
.then((result) => {
if (result.success) {

setTimeout(() => {
this.$toast.clear();
this.showToast("验证码已发送");


this.countdown = 60;

localStorage.setItem('verifyCodeCountdown', Date.now().toString());


if (this.countdownInterval) {
clearInterval(this.countdownInterval);
}

this.countdownInterval = setInterval(() => {
if (this.countdown > 0) {
this.countdown--;
} else {
clearInterval(this.countdownInterval);

localStorage.removeItem('verifyCodeCountdown');
}
}, 1000);
}, 1500);
}
})
.catch(err => {
console.error("获取验证码失败:", err);
Toast({ message: "网络异常，请稍后重试", position: 'top', duration: 2000 });
});
},


submitResetPassword() {

this.validateForm();
if (!this.isFormValid) return;


const encryptedData = {
phone: this.resetForm.phone,
verifyCode: this.resetForm.verifyCode,
newPassword: encrypt(this.resetForm.newPassword)
};


this.$toast.loading({
message: '提交中...',
forbidClick: true,
});
this.$ajax
.post(this.$api.dataReset, encryptedData)
.then((result) => {
if (result.success) {

setTimeout(() => {
this.$toast.clear();
this.showToast("密码重置成功");

setTimeout(() => {

localStorage.removeItem('verifyCodeCountdown');
this.$router.go(-1); 
}, 1500);
}, 2000);

}
}
)







}
}

};



// WEBPACK FOOTER //
// ./src/views/sys/Retrieve.vue